import { getMainApi } from "@Shared/@Utils/ajax";
export const get = (() => {
  const cache = {};
  return async service => {
    const endpoint = "/external-service";
    const cacheKey = service || "";
    if (cache[cacheKey]) {
      return cache[cacheKey];
    }
    const promise = getMainApi({
      name: cacheKey
    }, endpoint);
    cache[cacheKey] = promise;
    return promise;
  };
})();